import React from 'react';
import { SearchOutlined } from '@ant-design/icons';

export const FORM_CUSTOMER_DATA = ({ onEnter }) => {
  return [
    {
      name: 'telephone',
      type: 'INPUT_PHONE',
      span: 12,
      placeholder: '',
      label: 'เบอร์ติดต่อ (กรอกเบอร์ติดต่อแล้วกด Enter)',
      rules: {
        required: true,
        pattern: /^[0-9]{10}$/,
      },
      maxLength: 10,
      onEnter,
    },
    {
      name: 'fullName',
      type: 'INPUT',
      span: 12,
      placeholder: '',
      label: 'ชื่อ - นามสกุล',
      rules: {
        required: true,
      },
    },
  ];
};

export const FORM_PRODUCT_DATA = ({
  onEnter,
  mobileBrandList,
  channelBuyList,
  onEnterWarrantyCode,
  isWarrantyCodeEnabled,
  isWarrantyCodeRequired,
}) => {
  const accept = ['image/jpeg', 'image/png', 'image/jpg', 'image/bmp'];
  return [
    {
      name: 'barcodeShortcut',
      type: 'INPUT_BARCODE',
      placeholder: '',
      label: 'Barcode',
      rules: {
        required: true,
        pattern: /^[0-9]{9}$/,
      },
      maxLength: 9,
      onEnter,
    },
    {
      name: 'warrantyNumberCode',
      type: 'INPUT',
      placeholder: '',
      label: 'รหัสรับประกัน',
      disabled: !isWarrantyCodeEnabled,
      addonAfter: (value) => (
        <SearchOutlined
          style={{ cursor: 'pointer', color: 'gray' }}
          onClick={() => onEnterWarrantyCode(value)}
        />
      ),
      rules: {
        required: isWarrantyCodeRequired,
      },
      onEnter: onEnterWarrantyCode,
    },
    {
      name: 'productNameTh',
      type: 'INPUT',
      placeholder: '',
      label: 'ชื่อสินค้า',
      disabled: true,
      rules: {
        required: true,
      },
    },
    {
      name: 'productTypeName',
      type: 'INPUT',
      placeholder: '',
      label: 'ประเภทของสินค้า',
      disabled: true,
      rules: {
        required: true,
      },
    },
    {
      name: 'mobileBrandId',
      type: 'DROPDOWN',
      placeholder: '',
      label: 'ยี่ห้อ',
      properties: {
        options: mobileBrandList || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'mobileModelName',
      type: 'INPUT',
      placeholder: '',
      label: 'รุ่น',
      rules: {
        required: true,
      },
    },
    {
      name: 'channelBuyId',
      type: 'DROPDOWN',
      placeholder: '',
      label: 'ช่องทางการซื้อขาย',
      properties: {
        options: channelBuyList || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'purchaseDate',
      type: 'DATE_PICKER',
      placeholder: '',
      label: 'วันที่ซื้อสินค้า',
      format: 'YYYY-MM-DD',
      rules: {
        required: true,
      },
    },
    {
      name: 'pictureInfo',
      type: 'TEXT',
      placeholder: '',
      label: 'ชนิดรูปภาพที่ต้องการ (.png, .jpg, .jpeg, .bmp)',
    },
    {
      name: 'invImage',
      type: 'UPLOAD',
      label: 'รูปใบเสร็จ',
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      accept: accept.join(','),
      rules: {
        required: true,
      },
    },
    {
      name: 'packageImage',
      type: 'UPLOAD',
      label: 'รูปสินค้า',
      listType: 'picture-card',
      span: 12,
      maxCount: 1,
      accept: accept.join(','),
      rules: {
        required: true,
      },
    },

    {
      name: 'productId',
      type: 'HIDDEN',
    },
  ];
};
